import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SelectList } from '../models/select-list';

@Injectable({providedIn: 'root'})
export class EventService {
  private newEventSource = new BehaviorSubject<any>(null);
  currentEvent = this.newEventSource.asObservable();
  changeEvent(myEvent: any) {
    this.newEventSource.next(myEvent);
  }
}
